var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rank-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"rank",class:{'top': (_vm.index + 1) <= 3}},[_vm._v(_vm._s(_vm.index + 1))]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.itemData.title))]),_c('div',{staticClass:"extend"},[_vm._v(_vm._s(_vm.itemData.extend))])])
}
var staticRenderFns = []

export { render, staticRenderFns }